import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, of, take } from "rxjs";

import { Organization } from "../../../organizations/models/organizations.entity";
import { getOfferUpsellContent } from "../../../organizations/utils/plan-offer-marketing";
import { ProfileService } from "../../../users/services/profile.service";
import { OfferUpsellContent, UpsellContext } from "../../types/offer-upsell";

@Component({
    selector: 'app-subscribe-page',
    templateUrl: './subscribe-page.component.html',
    styleUrls: [ './subscribe-page.component.scss' ]
})

export class SubscribePageComponent implements OnInit {
    @Input() backgroundColor: string = '#dad3ea';

    @Input() height: string = '100dvh';

    @Input() context: UpsellContext = 'generic';

    @Input() title?: string;

    @Input() body?: string;

    @Input() benefits?: string[];

    @Input() primaryCtaLabel?: string;

    @Input() secondaryCtaLabel?: string;

    @Input() organization?: Organization | null;

    @Input() pricingRoute: string = '/offres-entreprises-2026';

    content: OfferUpsellContent = getOfferUpsellContent('generic');

    constructor(
        private readonly router: Router,
        private readonly profileService: ProfileService,
    ){}

    ngOnInit(): void {
        this.refreshContent(this.organization);

        if (this.organization) {
            return;
        }

        this.profileService
            .getMyProfile()
            .pipe(
                take(1),
                catchError(() => of(undefined)),
            )
            .subscribe(profile => {
                const organization = profile?.role === 'talker' ? profile.organization : undefined;
                this.refreshContent(organization);
            });
    }

    private refreshContent(organization?: Organization | null) {
        this.content = getOfferUpsellContent(this.context, organization);
    }

    get displayTitle(): string {
        return this.title ?? this.content.title;
    }

    get displayBody(): string {
        return this.body ?? this.content.body;
    }

    get displayBenefits(): string[] {
        return this.benefits?.length ? this.benefits : this.content.benefits;
    }

    get displayPrimaryCtaLabel(): string {
        return this.primaryCtaLabel ?? this.content.primaryCtaLabel;
    }

    get displaySecondaryCtaLabel(): string {
        return this.secondaryCtaLabel ?? this.content.secondaryCtaLabel;
    }

    goToPricing() {
        this.router.navigateByUrl(this.pricingRoute);
    }

    goToContact(){
        this.router.navigateByUrl('/questions');
    }
}
